


























import Vue from 'vue'
import Component from 'vue-class-component'
import UnifyPage from '@/shared/components/unify/unify-page.vue'
import HttpError from '@/shared/components/http-error.vue'
import { Injector } from '@/config/dependency-injection'
import { AccountModule } from '@/business/account/store/account-module'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import { loggerFor } from '@/shared/utils/logger'
import { CONFIRM_PASSWORD_CHANGE } from '@/business/account/store/types'
import { isNotBlank } from '@/shared/utils/is-blank'
import { Hooks } from '@/shared/interfaces/hooks'
import { RespondecoError } from '@/shared/utils/respondeco-error'

@Component({
  components: { HttpError, UnifyPage },
})
export default class ConfirmPasswordChange extends Vue implements Hooks {
  /**
   * The error that occurred when trying to confirm the account
   */
  public error: Response | null = null

  /**
   * Error specific description
   */
  public errorDescription: null | 'not_found' | 'no_token' = null

  /**
   * The organisation id of the confirmed account
   */
  public organisationId?: number

  /**
   * Indicates that the confirmation and the authentication were successful
   */
  public success = false

  private accountModule = Injector.get(AccountModule)
  private loaderHelper = Injector.get(LoaderHelper)
  private router = Injector.get<VueRouter>(RouterToken)

  private logger = loggerFor('ConfirmPasswordChange')

  get loading() {
    return this.loaderHelper.isLoading(CONFIRM_PASSWORD_CHANGE)
  }

  public mounted() {
    const token = this.router.currentRoute.query.token as string | undefined

    if (isNotBlank(token)) {
      this.confirmPasswordChange(token)
    } else {
      this.errorDescription = 'no_token'
    }
  }

  private confirmPasswordChange(token: string): void {
    this.accountModule
      .confirmPasswordChange({
        token,
      })
      .then(() => {
        this.success = true
      })
      .catch((cause: RespondecoError) => {
        this.logger.error(cause)

        this.error = cause.error

        const status = cause.error.status
        const type = cause.type

        if (type === 'confirmation') {
          if (status === 404) {
            this.errorDescription = 'not_found'
          }
        }
      })
  }
}
